import type { I_AccordionItemProps } from '@/types/AccordionItem';
import {
  AccordionItem as AccordionItemUI,
  AccordionTrigger,
  AccordionContent,
} from '@/ui/accordion';

export const AccordionItem = ({
  value,
  triggerContent,
  children,
  className = '',
  triggerClassName = '',
  contentClassName = '',
}: I_AccordionItemProps) => {
  return (
    <AccordionItemUI value={value} className={`rounded-lg border ${className}`}>
      <AccordionTrigger className={`px-4 py-3 hover:no-underline ${triggerClassName}`}>
        {triggerContent}
      </AccordionTrigger>
      <AccordionContent className={`px-4 pb-4 ${contentClassName}`}>{children}</AccordionContent>
    </AccordionItemUI>
  );
};
